<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="learning-path-categories"
            :items="lpCategories"
            :fields="categoryFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-lp-category"
                    v-b-modal="'create-category-modal'"
                    type="button"
                    label="create-new-lp-category"
                    variant="primary">
                    {{ $t('learning_path.add_work_field') }}
                </b-button>
            </template>
            <template v-slot:cell(assignments)="data">
                {{ data.item.lp_assignments ? data.item.lp_assignments.length : 0 }}
            </template>
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-lp-category"
                        v-b-tooltip.hoover
                        :title="$t('learning_path.open_work_field')"
                        variant="primary-icon-only"
                        @click="openCategory(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-lp-category btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="openEditCategory(data.item.id)">
                    </b-button>

                    <b-button
                        class="btn-remove btn-remove-lp-category"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeCategory(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-create-learning-path-category-modal
            @createCategory="createCategory($event)"
            ref="create-category-modal">
        </design-2021-create-learning-path-category-modal>
        <design-2021-edit-learning-path-category-modal
            @updateCategory="updateCategory($event)"
            ref="edit-category-modal">
        </design-2021-edit-learning-path-category-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-category-index-tab-component',
    props: {
        lpCategoriesIn: Array,
    },
    data() {
        return {
            lpCategories: this.lpCategoriesIn,
            categoryFields: [
                {
                    key: 'name',
                    label: this.$t('learning_path.work_field'),
                },
                {
                    key: 'assignments',
                    label: this.$t('learning_path.exercises'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        createCategory(data) {
            this.lpCategories.push(data);
            this.alert.success();
        },
        openEditCategory(categoryId) {
            const category = this.lpCategories.find((cat) => cat.id === categoryId);
            this.$refs['edit-category-modal'].show(category);
        },
        updateCategory(data) {
            this.lpCategories = this.lpCategories.map((category) => {
                if (category.id === data.id) {
                    const newCategory = { ...category, ...data };
                    return newCategory;
                } else {
                    return category;
                }
            });
            this.alert.success();
        },
        removeCategory(id) {
            this.alert
                .confirm(
                    this.$t('learning_path.delete_work_field'),
                    this.$t('learning_path.are_you_sure_you_want_to_delete_this_work_field'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.removeLpCategory(id)).then(
                        (response) => {
                            this.lpCategories = this.lpCategories.filter((item) => item.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        openCategory(id) {
            window.location.href = this.routes.LpCategoryAssignments(id);
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .btn {
        &:before {
            margin-right: 0;
        }
    }
}
</style>
